import AddAnimal from './containers/AddAnimal'

export default AddAnimal
